module.exports = __webpack_public_path__ + "static/media/banner_CIA_TERMAL_site_dourado_2.c1223cdb.jpg";